module.exports = __webpack_public_path__ + "media/4x3/py-bbc22e41.svg";